/**
 * Overrides layered on top of CSS_PRINT for the public report page. Two jobs: hide every
 * editing affordance that CSS can reach, and undo the popup-only layout the print styles
 * assume (side controls the public page has none of).
 *
 * Safe to apply document-wide only because /p/r/:uuid renders no app chrome.
 */
export default `
@media screen {
  /* On the popup these are only hidden when printing; here they never belong. Covers the
     edit-button clusters and any page the report author excluded. */
  .no-print {
    display: none !important;
  }

  /* CSS_PRINT nudges pages right to make room for the side controls; without them, center. */
  section {
    left: 0;
  }
}

/* Markers for the PDF export job, which waits on #report-ready via waitForSelector.
   That only matches "visible" elements (a bounding box, not display:none), so hide
   them from people without hiding them from the selector. */
#report-ready,
#report-error {
  position: fixed;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}
`;
